/**
 * Invites — per-email invites and shareable invite links.
 *
 * The onboarding sample trip has no real people to invite, so trip-scoped
 * invite actions on it return a friendly error (see demoUnavailable).
 */

import * as core from "@travelix/core";
import type { DbResult, InviteLink, InviteStatus, TravelerRole } from "@travelix/core";

import { isDemoTripId } from "@/lib/demo/demo-trip";
import { demoUnavailable, ok } from "./result";

// Not trip-scoped on the client (token- or invite-entry-based) — the sample
// trip can never reach these, so they're straight re-exports.
export {
  acceptTripInvite,
  denyTripInvite,
  getInviteLink,
  redeemInviteLink,
  revokeInviteLink,
} from "@travelix/core";

export async function listInviteLinksForTrip(tripId: string): Promise<DbResult<InviteLink[]>> {
  if (isDemoTripId(tripId)) return ok([]);
  return core.listInviteLinksForTrip(tripId);
}

export async function createInviteLink(
  ...args: Parameters<typeof core.createInviteLink>
): Promise<DbResult<InviteLink>> {
  if (isDemoTripId(args[0].id)) return demoUnavailable();
  return core.createInviteLink(...args);
}

export async function inviteUserToTrip(
  tripId: string,
  inviteeEmail: string,
  role: TravelerRole,
): Promise<DbResult<InviteStatus>> {
  if (isDemoTripId(tripId)) return demoUnavailable();
  return core.inviteUserToTrip(tripId, inviteeEmail, role);
}
